import { injectedStore } from '../../ConfigureStore';

export default function getBasicAuth(): string {
  return injectedStore.getState().userData.user.basicAuth;
}
